import React, { useCallback } from 'react';
import { Grid } from 'housecall-ui';

import { PricingFormOptionType } from '../../types/types';

import { PricingFormMultiSelectOption } from './PricingFormMultiSelectOption';

type Props = {
  options: PricingFormOptionType[];
  onChange: (value: number[]) => void;
  value: number[];
};

export const PricingFormMultiSelect = ({ options, onChange, value }: Props) => {
  const onClick = useCallback(
    (optionId: number) =>
      (newValue: boolean): void => {
        if (newValue) {
          onChange(value ? [...value, optionId] : [optionId]);
        } else {
          onChange(value ? value.filter((opt: number) => opt !== optionId) : []);
        }
      },
    [value, onChange]
  );

  const isActive = useCallback(
    (optionId: number): boolean => {
      if (Array.isArray(value)) {
        return value.includes(optionId);
      }
      return false;
    },
    [value]
  );

  return (
    <Grid container spacing={1}>
      {options.map((option) => (
        <PricingFormMultiSelectOption
          name={option.name}
          value={isActive(option.id)}
          onClick={onClick(option.id)}
          key={option.id}
          price={option.price || 0}
        />
      ))}
    </Grid>
  );
};
